"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hex = void 0;
const encode = (value) => Buffer.from(value, "utf8").toString("hex");
const decode = (value) => Buffer.from(value, "hex").toString();
exports.hex = { encode, decode };
//# sourceMappingURL=hex.js.map